<template>
  <Layout>
    <v-container class="fill-height d-flex flex-column align-center justify-center background" fluid>
      <component :is="imageUrl" class="logo" />

      <v-progress-circular
        :size="56"
        :width="5"
        indeterminate
        color="primary"
        class="my-6"
      />

      <div class="text-subtitle-1 text-center loading-text">
        Loading data, please wait...
      </div>
    </v-container>
  </Layout>
</template>

<script>
import Layout from '@layouts/no-navbar'

export default {
  page: {
    title: 'Loading page...',
    meta: [{ name: 'description', content: 'Loading page...' }]
  },
  components: { Layout },
  data() {
    return {
      imageUrl: () => import('@/components/svg/aetos-ai.vue')
    }
  }
}
</script>

<style scoped>

.logo {
  width: auto;
  height: 36px;
  opacity: 0.95;
  margin-bottom: 16px;
}

.loading-text {
  opacity: 0.85;
  font-weight: 500;
  font-size: 1.1rem;
}
</style>



// WEBPACK FOOTER //
// src/router/views/_loading.vue